import {computed} from "@vue/reactivity";
import {useWindowSize} from "@vueuse/core";

export function useMyFunctions(){
    const desktopSize = 1200;
    const mobileSize = 768;
    const isDesktop = computed(()=>{
        const {width} = useWindowSize()
        return (width.value > desktopSize)
    })
    const isMobile = computed(()=>{
        console.log("isMobile")
        const {width} = useWindowSize()
        console.log(width)
        return (width.value < mobileSize)
    })
    return {isDesktop,isMobile}
}